import React from 'react';
export function PainPointSection() {
  return <section className="w-full bg-sage py-16 px-4 flex flex-col items-center" data-id="element-71">
      <div className="max-w-3xl w-full text-center" data-id="element-72">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-10" data-id="element-73">
          Si sentís que la cocina te consume tiempo y cabeza, esto es para vos
        </h2>

        <div className="bg-white p-8 rounded-2xl shadow-sm border border-green-100 mb-10" data-id="element-74">
          <ul className="text-left max-w-xl mx-auto space-y-4" data-id="element-75">
            <li className="flex items-start gap-3" data-id="element-76">
              <span className="text-red-500 font-bold mt-1 text-xl" data-id="element-77">❌</span>
              <span className="text-brown-800 font-medium text-lg" data-id="element-78">
                Todos los días pensás qué cocinar
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-79">
              <span className="text-red-500 font-bold mt-1 text-xl" data-id="element-80">❌</span>
              <span className="text-brown-800 font-medium text-lg" data-id="element-81">
                El freezer está lleno pero no te ayuda
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-82">
              <span className="text-red-500 font-bold mt-1 text-xl" data-id="element-83">❌</span>
              <span className="text-brown-800 font-medium text-lg" data-id="element-84">
                Terminás improvisando o pidiendo comida
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-85">
              <span className="text-red-500 font-bold mt-1 text-xl" data-id="element-86">❌</span>
              <span className="text-brown-800 font-medium text-lg" data-id="element-87">
                Comprás sin orden y gastás de más
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-88">
              <span className="text-red-500 font-bold mt-1 text-xl" data-id="element-89">❌</span>
              <span className="text-brown-800 font-medium text-lg" data-id="element-90">
                Se te vence comida o no sabés qué tenés
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-91">
              <span className="text-red-500 font-bold mt-1 text-xl" data-id="element-92">❌</span>
              <span className="text-brown-800 font-medium text-lg" data-id="element-93">
                Sentís que nunca estás organizada del todo
              </span>
            </li>
          </ul>
        </div>

        <p className="font-bold text-brown-800 text-2xl md:text-3xl mt-8" data-id="element-94">
          ¿Cuánto tiempo más vas a seguir decidiendo todos los días lo mismo?
        </p>

        <div className="mt-12 flex justify-center" data-id="element-95">
          <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-lg py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 inline-flex items-center justify-center gap-2 w-full max-w-md" data-id="element-96">
            👉 QUIERO ACCEDER AHORA
          </a>
        </div>
      </div>
    </section>;
}